const { Feature, meta, hook, event } = checkApp.core;//eslint-disable-line

@meta('cnTips', ['suffixsService'], 999999)
export default class CNTipsFeature extends Feature {

  /**
   * 在 check 一个域名时执行  
   * @param {object} item 域名项
   * @return {void} 无返回
   */
  @hook('checkItem.check')
  async checkItem(item) {
    if (item.avail != 1) return;
    const productInfo = this.suffixsService.getDetailList();
    item.pmtHtml = (productInfo[item.suffix] || {}).pmtHtml;
  }

  parseTip(html) {
    return {
      link: /[\s\S]+href=[\"\'](.+?)[\"\']/ig.exec(html)[1],
      target: /[\s\S]+target=[\"\'](.+?)[\"\']/ig.exec(html)[1],
      message: html.replace(/\<[\s\S]+?\>/igm, '')
    };
  }

  /**
   * 在渲染 check 结果列表中域名后 label 时执行 
   * @param {Object} item 域名项
   * @param {Object} prevResult 上一个 hook 执行结果
   * @return {void} 要显示的 label
   */
  @hook('checkItem.renderLabel')
  renderLabel(item, prevResult) {
    if (!item.pmtHtml) return prevResult;
    const tip = this.parseTip(item.pmtHtml);
    return <a key={item.domain}
      href={tip.link}
      target={tip.target}
      className={'label label-warning hidden-xs hidden-sm'}>
      {tip.message}
    </a>;
  }
}


// WEBPACK FOOTER //
// ./src/tips/index.js